const constants = {
  is: "desktop",
  windW: 0,
  windH: 0,
  windOldW: 0,
  windOldH: 0,

  wresizetimer: 100,
  resizetimeout: 0,
  timerout: 0,

  zoomLevel: 100,

  scr: {
    phone: 0,
    tablet: 768,
    desktop: 1520,
  },
  
  slick: {
    edgeFriction: 0,
    speed: 300,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
  },
  fileTypes: {
    jpeg: "image/jpeg",
    pdf: "application/pdf",
  },
  lang: {
    el: "el",
    en: "en",
  },
  locale: {
    el: "el-GR",
    en: "en-GB",
  },
  gridGutterWidth: 24,
  gridGutterWidthMob: 26
};

export default constants;
